module.exports = __webpack_public_path__ + "static/img/11.cfdde25.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/skinAnalysis/11.png
// module id = QJtD
// module chunks = 1